module.exports = __webpack_public_path__ + "img/20200721_165114.dd835786.jpg";